export interface CostsArray {
  id: number;
  costCategoryId: number;
  detail: string;
  date: string;
  price: number;
}

export interface CategoryArray {
  id: number;
  category: string;
}

export interface ProjectArray {
  id: number;
  projectName: string;
}

export type CostsGetResponse = {
  categories: CategoryArray[];
  items: CostsArray[];
  projects: ProjectArray[];
};

export type CostItemUI = CostsArray & {
  category: string;
};

export type CostListUI = {
  items: CostItemUI[];
  categories: CategoryArray[];
  projects: ProjectArray[];
  categoryMap: Map<number, string>;
};

export const EmptyCostsGetResponse: CostsGetResponse = {
  categories: [
    {
      id: 0,
      category: '',
    },
  ],
  items: [],
  projects: [],
};
